exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.footer-area-wrapper[data-v-0c72f0c3]{\n    overflow-x: hidden;\n    padding-bottom: 0 !important;\n    margin-bottom: 0 !important;\n}\n", ""]);

